<template>
  <coupon-popup
    :dataSource="configData"
    :show="show"
    @close="closePopup"
    :showName="false"
  >
    <template #footDesc>
      <p class="foot-desc" @click="jumpCoupon">
        {{ $t('luckyDraw.award_desc.deposit') }}
      </p>
    </template>
  </coupon-popup>
</template>
<script>
  import { mapState, mapMutations } from 'vuex'
  import { getPopus, saveCoupon } from '@/api/activity/coupon'
  import { couponPopupShow } from '@/pages/firebase'
  import CouponPopup from '@/components/CouponPopup'
  import bus from '@/utils/bus'
  import { pagePopupShow } from '@/pages/marketingFirebase.js'

  // 优惠券提示
  export default {
    name: 'coupon-notice',
    components: {
      CouponPopup,
    },
    props: {
      loginStatus: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        show: false,
        imageLink: '',
        configData: {},
      }
    },
    computed: {
      ...mapState([
        'gameName',
        'region',
        'userInfo',
        'source',
        'isIAP',
        'members',
        'isApp',
      ]),
    },
    watch: {
      // warn： 为了解决、结果页回到详情页的时候 优惠券弹层不弹起的问题
      // warn: watch 只执行了一次，需要每次进入页面都执行一下下
      loginStatus: {
        handler(val) {
          if (val && !this.show) {
            this.getCouponData()
          }
        },
        immediate: true,
      },
    },
    mounted() {
      // 用于app内调用接口
      if (this.loginStatus && !this.show && this.isApp) {
        this.getCouponData()
      }
      // 初始化
      this.setIsSaveCoupon(false)
    },
    beforeDestroy() {
      bus.$off('existCouponActivity')
    },
    methods: {
      ...mapMutations(['setMembersModalBoxOrder']),
      ...mapMutations('detail', ['setIsSaveCoupon']),
      getCouponData() {
        // 用户登陆后，查询符合条件的活动弹窗
        const { region, gameName, source } = this
        // app内source从链接上取，默认'APP'
        let realSource = this.isApp
          ? this.$route.query?.source || 'APP'
          : source
        getPopus(region, gameName, realSource)
          .then((response) => {
            this.handleCouponDatas(response)
            bus.$emit('existCouponActivity', false)
          })
          .catch(() => {
            bus.$emit('existCouponActivity', false)
          })
      },
      handleCouponDatas(response) {
        const { couponList: list } = response
        // 初始化
        this.setIsSaveCoupon(false)
        if (Array.isArray(response)) {
          // 返回值为数组 不合法
          return
        }
        this.configData = response || {}
        const { activityId } = response.activity || {}
        // 提示弹窗打点
        if (list && list.length >= 1) {
          const page = this.gameName ? this.gameName : 'home'
          couponPopupShow({ act_id: activityId, popup_type: 'popup', page })

          // 优惠券已登录弹窗曝光
          pagePopupShow({
            page,
            act_id: activityId, // 活动编号
            popup_type: 'popup',
          })
        }
        const params = {
          activityId,
          couponIds: list && list.map((item) => item.id).join(','),
          // 1 游戏主题 2 电话卡 3 优惠券
          couponType: 3,
          timestamp: new Date().getTime(),
          country: this.region,
          source: this.isApp ? this.$route.query?.source || 'APP' : this.source,
        }
        if (list && list.length >= 1) {
          saveCoupon(params)
            .then(() => {
              this.show = this.isIAP ? false : true
              this.setIsSaveCoupon(true)
            })
            .catch(() => {
              window.console.log('优惠券保存报错')
            })
        }
      },
      closePopup() {
        this.show = false
      },
      jumpCoupon() {
        this.clearMemberModalBox()

        this.$router_push({
          path: `/coupon`,
          query: {
            ...this.$route.query,
            source: this.source,
          },
        })
      },
      // 【Hack】单独为会员的弹层做兼容
      clearMemberModalBox() {
        const { order = 3 } = this.members.modalBoxs

        // 当顺序为3的时候、证明已经被会员优惠券点击【消息全部已读】
        if (order === 3) return
        this.setMembersModalBoxOrder(1)
      },
    },
  }
</script>
